import { render } from "./beneficiary_id_order_by_power.vue?vue&type=template&id=4b7e4ff2&scoped=true"
import script from "./beneficiary_id_order_by_power.vue?vue&type=script&lang=js"
export * from "./beneficiary_id_order_by_power.vue?vue&type=script&lang=js"

import "./beneficiary_id_order_by_power.vue?vue&type=style&index=0&id=4b7e4ff2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b7e4ff2"]])

export default __exports__